import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {
  constructor(private toastr: ToastrService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          const status = err.status;
          const isServerError = status >= 500 && status < 600;
          const isApi = (req.url || '').includes('/api/');

          if (isServerError && isApi) {
            // Mensaje genérico dirigido al usuario (sin detalles técnicos)
            const body = 'No se ha podido acceder al recurso solicitado. Intente nuevamente más tarde.';
            try {
              this.toastr.error(body, undefined, { timeOut: 5000, closeButton: true });
            } catch {}
          }
        }
        return throwError(() => err);
      })
    );
  }
}